module.exports = __webpack_public_path__ + "static/img/PDF.893cd34b.png";